<kendo-datepicker bottomView="{{viewType}}" [(value)]="val" format="{{formatType}}" (valueChange)='dateChange($event)'>
</kendo-datepicker>

<kendo-dropdownlist class="k-dropdown-operator" [data]="List" [(ngModel)]="selectedItem" (valueChange)="dropdownChange($event)"
  [popupSettings]="{ width: 75 }"></kendo-dropdownlist>

<button class="k-button k-button-icon k-clear-button-visible" *ngIf="showClear">
  <span class="k-icon k-i-filter-clear" (click)="clearDate()"></span>
</button>